module.exports = __webpack_public_path__ + "img/ic-check-circle.df0ced59.svg";